import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, MessageCircle } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* About Section */}
          <div className="footer-section">
            <h3 className="footer-title">About Elderra</h3>
            <p className="footer-text">
              Empowering India's senior citizens with digital literacy and tools to navigate the modern world safely and independently.
            </p>
            <div className="footer-logo-container">
              <img 
                src="https://customer-assets.emergentagent.com/job_digital-seniors-3/artifacts/fqevhgzz_Elderra%20logo%20new%20original%20%281%29.png" 
                alt="Elderra Logo"
                className="footer-logo"
              />
            </div>
            <div className="footer-company-details">
              <p className="company-name">GIANT-TREE FOUNDATION</p>
              <p className="company-id">80G URN: AAMCG7420MF20261</p>
              <p className="company-id">PAN: AAMCG7420M</p>
              <p className="company-id" style={{ marginTop: 8, opacity: 0.85 }}>Services billed by <strong>GiantTreeTechnology Pvt Ltd</strong></p>
              <p className="company-id">GSTIN: 07AAICG7122N1ZA</p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/foundation" data-testid="footer-foundation-link">Elderra Foundation</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/community">Community</Link></li>
              <li><Link to="/donate">Donate</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Legal Links */}
          <div className="footer-section">
            <h3 className="footer-title">Legal</h3>
            <ul className="footer-links">
              <li><Link to="/terms">Terms of Use</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/data-deletion" data-testid="footer-data-deletion-link">Data Deletion Request</Link></li>
              <li><Link to="/refund">Refund Policy</Link></li>
              <li><Link to="/faqs">FAQs</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h3 className="footer-title">Our Services</h3>
            <ul className="footer-links">
              <li><a href="https://wa.me/919205070300?text=Hi%20Elderra%2C%20I%27d%20like%20to%20try%20the%20Voice%20Companion" target="_blank" rel="noopener noreferrer" data-testid="footer-voice-companion-link">Elderra Voice Companion</a></li>
              <li>DigiMitra Home Visits</li>
              <li>Community Meetups</li>
              <li>WhatsApp Groups</li>
              <li>Tech Training</li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-section">
            <h3 className="footer-title">Contact Us</h3>
            <div className="footer-contact">
              <div className="footer-contact-item">
                <Mail size={18} />
                <a href="mailto:helloelderra@gmail.com">helloelderra@gmail.com</a>
              </div>
              <div className="footer-contact-item">
                <Phone size={18} />
                <a href="tel:8920455730" style={{fontSize: '1.1rem', fontWeight: '600'}}>89204-55730</a>
              </div>
              <div className="footer-contact-item">
                <MessageCircle size={18} />
                <a href="https://wa.me/918920455730?text=Hi%20Elderra%2C%20I%20need%20help" target="_blank" rel="noopener noreferrer" style={{color: '#25D366', fontWeight: '500'}}>WhatsApp Us</a>
              </div>
              <div className="footer-contact-item">
                <MapPin size={18} />
                <span>India</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-mission">
          <p className="mission-statement">
            "Empowering independence and confidence in the digital world, ensuring every senior can embrace technology safely and joyfully."
          </p>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>© 2024 Giant-Tree Foundation - Bridging Tech for Elders. All rights reserved.</p>
            <div className="startup-india-badge">
              <img 
                src="https://customer-assets.emergentagent.com/job_digital-seniors-3/artifacts/qvp8avyl_png-transparent-government-of-india-startup-india-startup-company-entrepreneurship-india-company-text-orange-thumbnail.png" 
                alt="Startup India"
                className="startup-india-logo"
              />
              <span className="certificate-number">Certificate No: DIPP148826</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;